import React from 'react';

import { Link } from '@ergeon/core-components';

import errorPage from 'assets/error-page.svg';

const NotFoundPage = () => (
  <div className="mx-auto flex w-full max-w-2xl flex-col items-center gap-6 px-4 py-12 text-center">
    <img alt="" className="w-full" src={errorPage} />
    <h1 className="heading-3 text-gray-900 dark:text-white">Not Found</h1>
    <p className="paragraph-1 text-gray-700 dark:text-gray-300">
      This page does not exist or has moved. Search the wiki or open a section instead.
    </p>
    <Link className="paragraph-1 font-medium" href="/help">Open the Company Wiki</Link>
  </div>
);

export default NotFoundPage;
